import React from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import { ColumnName, ColumnNoc, ColumnResult, ColumnQualification, ColumnRank, ColumnExpander } from "components/common/TableColumns"
import Label from "components/general/Label"
import {
    RESULT_STATUS,
    getResultStatusAsInteger,
    isStartListStatus,
} from "helpers/status";
import { findArray } from 'helpers/utils'
import LoaderSubComponent from "components/general/LoaderSubComponent";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function ColumnHeat({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'LabelHeat',
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'startSortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Heat',
            Cell: (props) => {
                let group = findArray(props.cell.row.original.eventUnitEntries, { eue_code: ['GROUP'] });
                return group ? group.eue_pos : ''
            }
        }
    )
}

function ColumnStartOrder({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-center w-5',
    label = 'LabelStartOrder',
    accessor = 'startSortOrder'
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: accessor,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StartOrder',
        }
    )
}

function ColumnRun({
    disableSort = false,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    number,
    position,
    label = `Header${number}`,
}) {
    return (
        {
            Header: <Label data={label} sport={'SKB'} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Run ${number}`,
            Cell: (props) => {
                let value = findArray(props.cell.row.original.extendedResults, { er_pos: [`${position}`] });
                if (value?.er_value2 === 'Y')
                    return <div className="fw-bold">{value?.er_value}</div>
                else if (value?.er_irm)
                    return value?.er_irm
                else if (value?.er_discard)
                    return value?.er_discard
                else
                    return value ? value?.er_value : ''
            }
        }
    )
}

function ColumnTrick({
    disableSort = false,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    number,
    position,
    label = `Header${number}`,
}) {
    return (
        {
            Header: <Label data={label} sport={'SKB'} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: `Trick ${number}`,
            Cell: (props) => {
                let value = findArray(props.cell.row.original.extendedResults, { er_pos: [`${position}`] });
                if (value?.er_value2 === 'Y')
                    return <div className="fw-bold">{value?.er_value}</div>
                else if (value?.er_irm)
                    return value.er_irm
                else if (value?.er_discard)
                    return value?.er_discard
                else
                    return value ? value?.er_value : ''
            }
        }
    )
}

function TableColumnsQual(resultStatus) {
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.OFFICIAL || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL) {
        return (
            [
                ColumnRank({ disableSort: false }),
                ColumnHeat({ disableSort: false }),
                ColumnStartOrder({ disableSort: true }),
                ColumnNoc({ disableSort: true }),
                ColumnName({ disableSort: true }),
                {
                    id: 'HeaderRun',
                    Header: <Label data={'HeaderRun'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnRun({ disableSort: true, number: '1', position: '1' }),
                        ColumnRun({ disableSort: true, number: '2', position: '2' }),
                    ]
                },
                {
                    id: 'HeaderTrick',
                    Header: <Label data={'HeaderTRICK'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnTrick({ disableSort: true, number: '1', position: '3' }),
                        ColumnTrick({ disableSort: true, number: '2', position: '4' }),
                        ColumnTrick({ disableSort: true, number: '3', position: '5' }),
                        ColumnTrick({ disableSort: true, number: '4', position: '6' }),
                        ColumnTrick({ disableSort: true, number: '5', position: '7' }),
                    ]
                },
                ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
                ColumnQualification({ disableSort: true, className: "text-end fw-bold" })
            ]
        )
    }
    else {
        return (
            [
                ColumnRank({ disableSort: false }),
                ColumnHeat({ disableSort: false }),
                ColumnStartOrder({ disableSort: true }),
                ColumnNoc({ disableSort: false }),
                ColumnName({ disableSort: false }),
                {
                    id: 'HeaderRun',
                    Header: <Label data={'HeaderRun'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnRun({ disableSort: true, number: '1', position: '1' }),
                        ColumnRun({ disableSort: true, number: '2', position: '2' }),
                    ]
                },
                {
                    id: 'HeaderTrick',
                    Header: <Label data={'HeaderTRICK'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnTrick({ disableSort: true, number: '1', position: '3' }),
                        ColumnTrick({ disableSort: true, number: '2', position: '4' }),
                        ColumnTrick({ disableSort: true, number: '3', position: '5' }),
                        ColumnTrick({ disableSort: true, number: '4', position: '6' }),
                        ColumnTrick({ disableSort: true, number: '5', position: '7' }),
                    ]
                },
                ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
                ColumnQualification({ disableSort: true, className: "text-end fw-bold" })
            ]
        )
    }
}

function TableColumnsQualSM() {
    return (
        [
            ColumnRank({ disableSort: true }),
            ColumnHeat({ disableSort: true }),
            ColumnStartOrder({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ColumnQualification({ disableSort: true, className: "text-end fw-bold" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

function TableColumnsFinal(resultStatus) {
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.OFFICIAL || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL) {
        return (
            [
                ColumnRank({ disableSort: true }),
                ColumnStartOrder({ disableSort: true }),
                ColumnNoc({ disableSort: true }),
                ColumnName({ disableSort: true }),
                {
                    id: 'HeaderRun',
                    Header: <Label data={'HeaderRun'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnRun({ disableSort: true, number: '1', position: '1' }),
                        ColumnRun({ disableSort: true, number: '2', position: '2' }),
                    ]
                },
                {
                    id: 'HeaderTrick',
                    Header: <Label data={'HeaderTRICK'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnTrick({ disableSort: true, number: '1', position: '3' }),
                        ColumnTrick({ disableSort: true, number: '2', position: '4' }),
                        ColumnTrick({ disableSort: true, number: '3', position: '5' }),
                        ColumnTrick({ disableSort: true, number: '4', position: '6' }),
                        ColumnTrick({ disableSort: true, number: '5', position: '7' }),
                    ]
                },
                ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ]
        )
    }
    else if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST) {
        return (
            [
                ColumnRank({ disableSort: false }),
                ColumnStartOrder({ disableSort: true }),
                ColumnNoc({ disableSort: true }),
                ColumnName({ disableSort: true }),
                {
                    id: 'HeaderRun',
                    Header: <Label data={'HeaderRun'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnRun({ disableSort: true, number: '1', position: '1' }),
                        ColumnRun({ disableSort: true, number: '2', position: '2' }),
                    ]
                },
                {
                    id: 'HeaderTrick',
                    Header: <Label data={'HeaderTRICK'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnTrick({ disableSort: true, number: '1', position: '3' }),
                        ColumnTrick({ disableSort: true, number: '2', position: '4' }),
                        ColumnTrick({ disableSort: true, number: '3', position: '5' }),
                        ColumnTrick({ disableSort: true, number: '4', position: '6' }),
                        ColumnTrick({ disableSort: true, number: '5', position: '7' }),
                    ]
                },
                ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ]
        )
    }
    else {
        return (
            [
                ColumnRank({ disableSort: false }),
                ColumnStartOrder({ disableSort: false }),
                ColumnNoc({ disableSort: false }),
                ColumnName({ disableSort: false }),
                {
                    id: 'HeaderRun',
                    Header: <Label data={'HeaderRun'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnRun({ disableSort: true, number: '1', position: '1' }),
                        ColumnRun({ disableSort: true, number: '2', position: '2' }),
                    ]
                },
                {
                    id: 'HeaderTrick',
                    Header: <Label data={'HeaderTRICK'} />,
                    headerClassName: "text-center",
                    columns: [
                        ColumnTrick({ disableSort: true, number: '1', position: '3' }),
                        ColumnTrick({ disableSort: true, number: '2', position: '4' }),
                        ColumnTrick({ disableSort: true, number: '3', position: '5' }),
                        ColumnTrick({ disableSort: true, number: '4', position: '6' }),
                        ColumnTrick({ disableSort: true, number: '5', position: '7' }),
                    ]
                },
                ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ]
        )
    }
}

function TableColumnsFinalSM() {
    return (
        [
            ColumnStartOrder({ disableSort: true }),
            ColumnRank({ disableSort: true }),
            ColumnNoc({ disableSort: true }),
            ColumnName({ disableSort: true }),
            ColumnResult({ disableSort: true, label: "HeaderTotal", className: "text-end fw-bold" }),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

//LOADS QUALIFICATION SCORE TABLE
const SkbScoreBoardStreetQual = ({ data }) => {

    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    let columns = (breakPoint === "sm" || breakPoint === "xs") ? TableColumnsQualSM() : TableColumnsQual(resultStatus)
    let hiddenColumns = []

    let showQualMark = data?.results?.items?.some(item => item.qualificationMark);
    if (!showQualMark)
        hiddenColumns.push('QualMark')
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST) {
        hiddenColumns.push('Rank')
        hiddenColumns.push('Run 1')
        hiddenColumns.push('Run 2')
        hiddenColumns.push('Trick 1')
        hiddenColumns.push('Trick 2')
        hiddenColumns.push('Trick 3')
        hiddenColumns.push('Trick 4')
        hiddenColumns.push('Trick 5')
    }
    if ((getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST ||
        getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE) &&
        (breakPoint === "sm" || breakPoint === "xs")) {
        hiddenColumns.push('StartOrder')
    }
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL && (breakPoint === "sm" || breakPoint === "xs")) {
        hiddenColumns.push('StartOrder')
        hiddenColumns.push('Heat')
    }
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.OFFICIAL || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL) {
        hiddenColumns.push('StartOrder')
    }
    let currentPlayer = data?.results?.currentCompetitorResult?.participant?.code

    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} />
        }
        />
    ), [resultStatus]);

    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.INTERMEDIATE
                            ?
                            <>
                                <div className='competitor-current bmf-scoreboard-header'>
                                    <div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                    <div className='justify-content-end fw-bold'><Label data={'LabelInProgress'} /></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='bmf-scoreboard-header'>
                                    {isStartListStatus(resultStatus)
                                        ? <><div className='justify-content-start fw-bold'><Label data={'HeaderStartList'} /></div></>
                                        : getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL
                                            ?
                                            <><div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                                <div className='justify-content-end fw-bold'><Label data={'HeaderFinished'} /></div></>
                                            :
                                            <><div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                                <div className='justify-content-end fw-bold'><Label data={'HeaderOfficial'} /></div></>

                                    }
                                </div>
                            </>
                        }
                        < MirsTable
                            //Dato to show by row
                            data={data?.results?.items}
                            //Columnas a visualizar 
                            columns={columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            hiddenColumns={hiddenColumns}
                            renderRowSubComponent={renderRowSubComponent}
                            initialSortBy={isStartListStatus(resultStatus)
                                ? [{ id: 'Heat', desc: false }]
                                : [{ id: 'Rank', desc: false }]}
                            id={`mirs-table-result-${rsc}`}
                            getRowProps={row => ({
                                className: currentPlayer?.includes(row?.original?.participant?.code) ? 'currentIndicator' : '',
                            })}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
}









//LOADS FINAL SCORE TABLE
const SkbScoreBoardStreetFinal = ({ data }) => {
    const { breakPoint } = useViewport();
    const resultStatus = data?.results?.status?.code;
    const rsc = data?.results?.eventUnitCode;

    let columns = (breakPoint === "sm" || breakPoint === "xs") ? TableColumnsFinalSM() : TableColumnsFinal(resultStatus)
    let hiddenColumns = []

    let showQualMark = data?.results?.items?.some(item => item.qualificationMark);

    if (!showQualMark)
        hiddenColumns.push('QualMark')
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.START_LIST) {
        hiddenColumns.push('Rank')
        hiddenColumns.push('Run 1')
        hiddenColumns.push('Run 2')
        hiddenColumns.push('Trick 1')
        hiddenColumns.push('Trick 2')
        hiddenColumns.push('Trick 3')
        hiddenColumns.push('Trick 4')
        hiddenColumns.push('Trick 5')
    }
    if (breakPoint === "sm" || breakPoint === "xs" && getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE) {
        hiddenColumns.push('StartOrder')
    }
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL && (breakPoint === "sm" || breakPoint === "xs")) {
        hiddenColumns.push('StartOrder')
    }
    if (getResultStatusAsInteger(resultStatus) === RESULT_STATUS.OFFICIAL || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL) {
        hiddenColumns.push('StartOrder')
    }

    let currentPlayer = data?.results?.currentCompetitorResult?.participant?.code

    const renderRowSubComponent = React.useCallback(({ row }) => (
        <LoaderSubComponent component={
            <TableExpanded row={row?.original} />
        }
        />
    ), [resultStatus]);

    return (
        <>
            {data?.results?.items
                ? (
                    <>
                        {getResultStatusAsInteger(resultStatus) === RESULT_STATUS.LIVE || getResultStatusAsInteger(resultStatus) === RESULT_STATUS.INTERMEDIATE
                            ?
                            <>
                                <div className='competitor-current bmf-scoreboard-header'>
                                    <div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                    <div className='justify-content-end fw-bold'><Label data={'LabelInProgress'} /></div>
                                </div>
                            </>
                            :
                            <>
                                <div className='bmf-scoreboard-header'>
                                    {isStartListStatus(resultStatus)
                                        ? <><div className='justify-content-start fw-bold'><Label data={'HeaderStartList'} /></div></>
                                        : getResultStatusAsInteger(resultStatus) === RESULT_STATUS.UNOFFICIAL
                                            ?
                                            <><div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                                <div className='justify-content-end fw-bold'><Label data={'HeaderFinished'} /></div></>
                                            :
                                            <><div className='justify-content-start fw-bold'><Label data={'HeaderResults'} /></div>
                                                <div className='justify-content-end fw-bold'><Label data={'HeaderOfficial'} /></div></>

                                    }
                                </div>
                            </>
                        }
                        < MirsTable
                            //Dato to show by row
                            data={data?.results?.items}
                            //Columnas a visualizar 
                            columns={columns}
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            hiddenColumns={hiddenColumns}
                            renderRowSubComponent={renderRowSubComponent}
                            initialSortBy={isStartListStatus(resultStatus)
                                ? [{ id: 'StartOrder', desc: false }]
                                : [{ id: 'Rank', desc: false }]}
                            id={`mirs-table-result-${rsc}`}
                            getRowProps={row => ({
                                className: currentPlayer?.includes(row?.original?.participant?.code) ? 'currentIndicator' : '',
                            })}
                        />

                    </>
                ) : (
                    ''
                )
            }
        </>
    );
}


const SkbScoreboard = ({ data }) => {
    return data?.results?.eventUnitCode.includes('FNL') ? <SkbScoreBoardStreetFinal data={data} /> : <SkbScoreBoardStreetQual data={data} />
};

const TableExpanded = React.memo((props) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let run1 = props?.row?.extendedResults?.find(er => er?.er_pos === '1') ? props?.row?.extendedResults?.find(er => er?.er_pos === '1') : ''

    let run2 = props?.row?.extendedResults?.find(er => er?.er_pos === '2') ? props?.row?.extendedResults?.find(er => er?.er_pos === '2') : ''

    let trick1 = props?.row?.extendedResults?.find(er => er?.er_pos === '3') ? props?.row?.extendedResults?.find(er => er?.er_pos === '3') : ''

    let trick2 = props?.row?.extendedResults?.find(er => er?.er_pos === '4') ? props?.row?.extendedResults?.find(er => er?.er_pos === '4') : ''

    let trick3 = props?.row?.extendedResults?.find(er => er?.er_pos === '5') ? props?.row?.extendedResults?.find(er => er?.er_pos === '5') : ''

    let trick4 = props?.row?.extendedResults?.find(er => er?.er_pos === '6') ? props?.row?.extendedResults?.find(er => er?.er_pos === '6') : ''

    let trick5 = props?.row?.extendedResults?.find(er => er?.er_pos === '7') ? props?.row?.extendedResults?.find(er => er?.er_pos === '7') : ''

    return (
        <>
            <table class="table">
                <thead>
                    <tr>
                        <th className="text-center" colSpan="2" scope="col"><Label data={'HeaderRun'} /></th>
                        <th className="text-center" colSpan="5" scope="col"><Label data={'HeaderTRICK'} /></th>
                    </tr>
                    <tr>
                        <th className="text-center" ><Label data="Header1" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header2" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header1" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header2" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header3" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header4" sport={mirs_discipline} /></th>
                        <th className="text-center" ><Label data="Header5" sport={mirs_discipline} /></th>
                    </tr>
                </thead>
                <tbody>
                    {run1 ? getResults(props?.row, run1?.er_pos) : ''}
                    {run2 ? getResults(props?.row, run2?.er_pos) : ''}
                    {trick1 ? getResults(props?.row, trick1?.er_pos) : ''}
                    {trick2 ? getResults(props?.row, trick2?.er_pos) : ''}
                    {trick3 ? getResults(props?.row, trick3?.er_pos) : ''}
                    {trick4 ? getResults(props?.row, trick4?.er_pos) : ''}
                    {trick5 ? getResults(props?.row, trick5?.er_pos) : ''}
                </tbody>
            </table>
        </>
    )
});

const getResults = (competitor, number) => {

    let result = competitor?.extendedResults?.find(er => er?.er_pos === number) ? competitor?.extendedResults?.find(er => er?.er_pos === number) : ''

    if (result?.er_value2 === 'Y')
        return <td className="text-center fw-bold">{result?.er_value}</td>
    else if (result?.er_irm)
        return <td className="text-center">{result?.er_irm}</td>
    else if (result?.er_discard)
        return <td className="text-center">{result?.er_discard}</td>
    else
        return <td className="text-center">{result?.er_value}</td>
}

export default SkbScoreboard;

